import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import Navigation from 'components/Navigation';
import Loading from 'components/library/Loading';
import Error from 'views/Error';
import { setProjectId } from '../store/features/project/actions';
import verifyToken from '../store/features/roles/actions';
var ROUTES = [
    {
        path: '/:id/configuration/*',
        component: React.lazy(function () { return import('views/Configuration'); }),
        auth: true,
    },
    {
        path: '/:id/report',
        component: React.lazy(function () { return import('views/Report'); }),
        auth: true,
    },
    {
        path: '/:id/investors',
        component: React.lazy(function () { return import('views/ReportInvestors'); }),
        auth: true,
    },
    {
        path: '/:id/contacts/:status',
        component: React.lazy(function () { return import('views/Contacts'); }),
        auth: true,
    },
    {
        path: '/:id/contacts',
        component: React.lazy(function () { return import('views/Contacts'); }),
        auth: true,
    },
    {
        path: '/:id',
        component: React.lazy(function () { return import('views/Dashboard'); }),
        auth: true,
    },
    {
        path: '/server-maintenance',
        component: React.lazy(function () { return import('views/ServerError'); }),
        auth: true,
    },
    {
        path: '/',
        component: React.lazy(function () { return import('views/Error'); }),
        auth: true,
    },
];
export default function RouteConfig() {
    return (_jsx(Router, { children: _jsx("div", { className: "main", children: _jsx(Suspense, { fallback: _jsx(Loading, {}), children: _jsx(Routes, { children: ROUTES.map(function (route) { return (_jsx(Route, { path: route.path, element: _jsx(ConnectedRouteWithSubRoutes, { route: route }) }, route.path)); }) }) }) }) }));
}
function RouteWithSubRoutes(_a) {
    var route = _a.route, status = _a.status;
    var dispatch = useDispatch();
    useEffect(function () {
        var id = window.location.pathname.split('/')[1];
        if (route.auth) {
            dispatch(verifyToken());
        }
        dispatch(setProjectId(id));
    }, [dispatch]);
    if (status === 'SUCCEEDED') {
        return (_jsxs(_Fragment, { children: [route.path !== "/" && _jsx(Navigation, {}), _jsx(route.component, {})] }));
    }
    else if (status === 'IDLE' || status === 'LOADING') {
        return _jsx(Loading, {});
    }
    return _jsx(Error, {});
}
var mapStateToProps = function (state) { return ({
    status: state.roles.status,
}); };
var ConnectedRouteWithSubRoutes = connect(mapStateToProps)(RouteWithSubRoutes);
